import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const WaitlistForm = ({ variant = "hero" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const isHero = variant === "hero";

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email });
      toast.success("Added to the waitlist", {
        description: "We will reach out when early access opens.",
      });
      setEmail("");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error("Could not join waitlist", {
        description: typeof detail === "string" ? detail : "Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid={`waitlist-form-${variant}`}
      className={isHero ? "flex flex-col sm:flex-row gap-3" : "flex gap-2"}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={isHero ? "Enter developer email..." : "dev@team.com"}
        data-testid={`waitlist-email-input-${variant}`}
        className={
          isHero
            ? "bg-coal border border-seam rounded-lg px-4 py-3 text-sm text-white placeholder-smoke focus:outline-none focus:border-ember flex-1 transition-colors"
            : "bg-coal border border-seam rounded-lg px-4 py-2 text-xs text-white placeholder-smoke focus:outline-none focus:border-ember flex-1 transition-colors"
        }
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`waitlist-submit-${variant}`}
        className={
          isHero
            ? "bg-ember hover:bg-ember-deep disabled:opacity-60 text-black font-semibold rounded-lg px-6 py-3 text-sm transition-colors whitespace-nowrap"
            : "bg-ember hover:bg-ember-deep disabled:opacity-60 text-black font-semibold rounded-lg px-4 py-2 text-xs transition-colors whitespace-nowrap"
        }
      >
        {loading ? "Joining..." : isHero ? "Join Waitlist" : "Join"}
      </button>
    </form>
  );
};
